import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import CustomLoader from '../common/CustomLoader';
import CustomSelect from '../home/collections/CustomSelect';
import ParentContentCard from '../common/ParentContentCard';
import { dropdownsForSource } from '../../common/utils/data_source-util';
import { convertFields, getFieldDataTypeValue } from './common/common_utils';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class AirtableCollectionCreate extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    selectedCollectionIndex: 0,
    fieldDatatypes: [],
    airtableCollection: '',
  };
  async componentDidMount() {
    if (this.props.location.state) {
      const { collectionIndex } = this.props.location.state;
      this.setState({ selectedCollectionIndex: collectionIndex });
    }
    const { match, actions } = this.props;
    const { externalDbUuid, projectId, version } = match.params;
    await actions.loadExternalDatabaseForAirtable({
      projectId,
      externalDbUuid,
      version,
    });
    this.setState({ airtableCollection: this.props.dataConnector.externalDbAirtable });
  }
  checkCollectionIndex = (state) => {
    if (state) {
      if (state.collectionIndex >= 0) {
        return true;
      }
    }
    return false;
  };
  handleCollection = () => {
    const { match, location } = this.props;
    const { projectId, externalDbUuid, version } = match.params;
    if (this.checkCollectionIndex(location.state)) {
      this.props.history.push(
        `/data-connector/${version}/v/${projectId}/airtable-edit/${externalDbUuid}`,
      );
    } else {
      const { selectedCollectionIndex, airtableCollection } = this.state;
      const newArray = airtableCollection.completeData['tables'];
      const totalLengh = newArray.length - 1;
      if (selectedCollectionIndex < totalLengh) {
        this.setState({ selectedCollectionIndex: selectedCollectionIndex + 1 });
      } else {
        this.props.history.push(`/collections/${version}/v/${projectId}`);
      }
    }
  };
  handleSave = async () => {
    const { selectedCollectionIndex, fieldDatatypes, airtableCollection } = this.state;
    const { actions, match } = this.props;
    const { completeData, setting } = airtableCollection;
    const { database } = completeData;
    const newArray = completeData['tables'];
    const selectedData = newArray[selectedCollectionIndex];
    const fieldData = selectedData.fields;
    const result = {};
    Object.keys(fieldData).map((fieldName, index) => {
      result[fieldName] = fieldDatatypes[fieldName]
        ? fieldDatatypes[fieldName].value
        : fieldData[fieldName];
    });
    const newResult = convertFields(result);
    const { projectId, externalDbUuid, version } = match.params;
    const data = {
      version,
      collectionTitle: selectedData.collectionName,
      willPersist: false,
      fields: newResult,
      projectId,
      externalDatabaseId: externalDbUuid,
      setting,
      baseId: database.id,
      tableId: selectedData.collectionId,
    };
    await actions.createCollectionWithAirtable(data);
    await actions.airtableUpdateExternalDatabase({
      projectId,
      externalDbUuid,
      fields: newResult,
      version,
      collectionId: selectedData.collectionId,
    });
    this.handleCollection();
  };

  handleFieldChange = (fieldName, selectedValue) => {
    const updatedResult = { ...this.state.fieldDatatypes };
    updatedResult[fieldName[0]] = selectedValue;
    this.setState({ fieldDatatypes: updatedResult });
  };
  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }

    const { dataConnector } = this.props;
    const {
      loadExternalDatabaseForAirtablePending,
      createCollectionWithAirtablePending,
      airtableUpdateExternalDatabasePending,
    } = dataConnector;
    const { airtableCollection, selectedCollectionIndex } = this.state;
    const { completeData } = airtableCollection;
    const selectedCollection = completeData
      ? completeData['tables'][selectedCollectionIndex]
      : null;

    const fieldData = selectedCollection ? selectedCollection.fields : null;
    return fieldData ? (
      <CommonPageComponent>
        <ParentContentCard
          title={'Choose Collection for Create Or Skip via Airtable'}
          icon={'collection'}
        >
          <Formik initialValues={{ collectionTitle: selectedCollection.collectionName }}>
            {({ values, handleChange, setFieldValue }) => (
              <Form className="ml-5">
                <div className="col-md-11 col-lg-11 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Name"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Airtable collection name'}
                    >
                      <Field
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Collection Name"
                        readOnly
                        value={selectedCollection.collectionName}
                      />
                    </FormFieldWithLabel>
                  </div>

                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Title"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Enter name for the collection name if  you want to change'}
                      value={selectedCollection.collectionName}
                    >
                      <Field
                        type="text"
                        name="collectionTitle"
                        className="form-control form-control-sm"
                        placeholder="Collection Title"
                      />
                      <ErrorMessage name="collectionTitle" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>
                  <hr style={{ marginBottom: '20px', visibility: 'hidden' }} />
                  <div className="mt-2">
                    <h5>
                      <b>Field Type Mapping</b>
                    </h5>
                  </div>
                  <div
                    className="table-responsive"
                    style={{
                      overflow: 'visible',
                      maxHeight: 'fit-content',
                      marginBottom: '10px',
                    }}
                  >
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th style={{ width: '50%' }}>Fields</th>
                          <th style={{ width: '50%' }}>Types</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(fieldData).map((fieldName, index) => (
                          <tr key={index}>
                            <td style={{ width: '50%' }}>{fieldName}</td>
                            <td style={{ width: '50%' }}>
                              <CustomSelect
                                name={fieldName}
                                isMulti={false}
                                onChange={setFieldValue}
                                onChangeValue={this.handleFieldChange}
                                options={dropdownsForSource}
                                value={getFieldDataTypeValue(
                                  fieldName,
                                  fieldData,
                                  this.state.fieldDatatypes,
                                )}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn btn-outline-secondary btn-md"
                      title="Cancel"
                      type="button"
                      onClick={this.handleCollection}
                    >
                      <i className="wb webconnect-times"></i> Skip & Continue
                    </button>
                    <button
                      type="button"
                      className="btn btn-theme-submit btn-md"
                      title="Save Collection"
                      onClick={this.handleSave}
                      disabled={
                        createCollectionWithAirtablePending || airtableUpdateExternalDatabasePending
                      }
                    >
                      <i className="wb webconnect-save-regular"></i> Save & Continue
                      <CustomLoader
                        loading={
                          createCollectionWithAirtablePending ||
                          airtableUpdateExternalDatabasePending
                        }
                      />
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    ) : (
      <CommonPageComponent>
        <div className="text-center">
          <CustomLoader
            loading={loadExternalDatabaseForAirtablePending}
            size="20px"
            color="#303453"
          />
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AirtableCollectionCreate);
